import React, { useContext, useEffect, useState } from "react";
import { db } from "../../firebase-config";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  addDoc,
  query,
  where,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { UserContext } from "../../UserContext";
import Button from "../../Components/forms/Button";
import Input from "../../Components/forms/Input";
import styles from "./OfertaContextual.module.css";
import { ReactComponent as LogoOfertas } from "../../assets/ic_linkred.svg";
import IconInfoHelp from "../../assets/about_description_help_info_information_icon.svg";
import { checkPermissions } from "../../utils/standaloneUtils";

import Modal from "react-modal";
import SelectField from "../../Components/SelectField/SelectField";
import { Alert } from "bootstrap";

var abc = []
var selectedItems = []

var selectedItemsStatus = []
var tempSelectedItemsStatus = []

const OfertaContextual = () => {
  const [tituloNotificacao, setTituloNotificacao] = useState("");
  const [txtConteudo, setTxtConteudo] = useState(""); //conteúdo
  const [produto, setProduto] = useState("");
  const [espacoComercial, setEspacoComercial] = useState("");
  const [urlImgMobile, setUrlImgMobile] = useState("");
  const [urlImgDesktop, setUrlImgDesktop] = useState("");
  const [linkCtaDesktop, setLinkCtaDesktop] = useState("");
  const [linkCtaMobile, setLinkCtaMobile] = useState("");
  const [txtCtaBannerDesktop, setTxtCtaBannerDesktop] = useState("");
  const [txtCtaBannerMobile, setTxtCtaBannerMobile] = useState("");
  const [corCta, setCorCta] = useState(""); // branco ou vermelho
  const [corTxtCta, setCorTxtCta] = useState(""); // branco ou vermelho
  const [corTxtConteudo, setCorTxtConteudo] = useState(""); // branco ou preto
  const [status, setStatus] = useState("");
  const [docID, setDocID] = useState("");

  const [espacoComercialError, setEspacoComercialError] = useState(false);
  const [produtoError, setProdutoError] = useState(false);
  const [statusError, setStatusError] = useState(false);
  const [tituloNotificacaoError, setTituloNotificacaoError] = useState(false);
  const [txtConteudoError, setTxtConteudoError] = useState(false);
  const [urlImgDesktopError, setUrlImgDesktopError] = useState(false);
  const [linkCtaDesktopError, setLinkCtaDesktopError] = useState(false);
  const [txtCtaBannerDesktopError, setTxtCtaBannerDesktopError] = useState(false);
  const [urlImgMobileError, setUrlImgMobileError] = useState(false);
  const [linkCtaMobileError, setLinkCtaMobileError] = useState(false);
  const [txtCtaBannerMobileError, setTxtCtaBannerMobileError] = useState(false);
  const [corCtaError, setCorCtaError] = useState(false);
  const [corTxtCtaError, setCorTxtCtaError] = useState(false);
  const [corTxtConteudoError, setCorTxtConteudoError] = useState(false);

  const [saveButtonState, setSaveButtonState] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [showBtSave, setShowBtSave] = useState(false);
  const [showBtUpdate, setShowBtUpdate] = useState(false);
  const [showBtEdit, setShowBtEdit] = useState(false);
  const [showBtDelete, setShowBtDelete] = useState(false);
  const [showBtAddNew, setShowBtAddNew] = useState(true);
  const [showBtPub, setShowBtPub] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenPub, setIsOpenPub] = useState(false);
  const [isOpenMsg, setIsOpenMsg] = useState(false);
  const [txtModal, setTxtModal] = useState('');
  const [disabledBanner, setDisabledBanner] = useState(false);
  const [disabledNotification, setDisabledNotification] = useState(false);

  const { permission, modules } = useContext(UserContext);

  const initialData = [
    {
      tituloNotificacao: "Carregando...",
      txtConteudo: "Carregando...",
      produto: "Carregando...",
      espacoComercial: "Carregando...",
      urlImgMobile: "Carregando...",
      urlImgDesktop: "Carregando...",
      linkCtaDesktop: "Carregando...",
      linkCtaMobile: "Carregando...",
      txtCtaBannerDesktop: "Carregando...",
      txtCtaBannerMobile: "Carregando...",
      corCta: "Carregando...",
      corTxtCta: "Carregando...",
      corTxtConteudo: "Carregando...",
      status: "Carregando...",
      docID: "Carregando...",
    },
  ];

  const accessModule = {
    "web_push": "admin",
    "oferta_contextual": "admin",
    "vitrine": "admin",
    "dashboards": "admin",
  }

  function showHideButtons() {
    if (checkPermissions('oferta_contextual', modules, permission) > 2) {
      return (
        <>
          <div className={styles.buttonOfertas}>
            {showBtPub && (
              <button
                className={styles.addButtonGreen}
                onClick={(event) => {
                  setIsOpenPub(true);
                }}
              >
                Publicar
              </button>
            )}

            {!showBtAddNew && (
              <button className={styles.oferButton}>
                Adicionar
              </button>
            )}
            {showBtAddNew && (
              <button
                className={styles.addButton}
                onClick={(event) => {
                  setShowForm(true);
                  setShowBtEdit(false);
                  setShowBtDelete(false);
                  setShowBtAddNew(false);
                  setShowBtSave(true);
                  setShowBtUpdate(false);
                  clearData();
                }}
              >
                Adicionar
              </button>
            )}

            {!showBtEdit && (
              <button className={styles.oferButton}>
                Editar
              </button>
            )}
            {showBtEdit && (
              <button
                className={styles.addButton}
                onClick={(event) => {
                  setShowBtUpdate(true);
                  setShowBtSave(false);
                  getValuesEditData();
                }}
              >
                Editar
              </button>
            )}

            {!showBtDelete && (
              <button className={styles.oferButton}>
                Excluir
              </button>
            )}
            {showBtDelete && (
              <button
                className={styles.addButton}
                onClick={(event) => {
                  setIsOpen(true);
                  // deleteDataMultipleItems();
                }}
              >
                Excluir
              </button>
            )}
          </div>
        </>
      );
    }
    return null;
  }

  const [allData, setAllData] = useState(initialData);

  useEffect(() => {
    getAll();
  }, []);

  function areAllFieldsFilled(fields) {
    return Object.values(fields).every(value => value.trim() !== '');
  }

  useEffect(() => {

    let allFieldsFilled = false;

    if (espacoComercial === 'banner') {
      allFieldsFilled =
        espacoComercial &&
        produto &&
        status &&
        txtConteudo &&
        urlImgDesktop &&
        linkCtaDesktop &&
        txtCtaBannerDesktop &&
        urlImgMobile &&
        linkCtaMobile &&
        txtCtaBannerMobile &&
        corCta &&
        corTxtCta &&
        corTxtConteudo;
    } else if (espacoComercial === 'notificacao') {
      allFieldsFilled =
        espacoComercial &&
        produto &&
        status &&
        txtConteudo &&
        tituloNotificacao &&
        txtConteudo &&
        linkCtaDesktop &&
        linkCtaMobile;
    }
    setSaveButtonState(allFieldsFilled);
  }, [
    espacoComercial,
    produto,
    status,
    txtConteudo,
    urlImgDesktop,
    linkCtaDesktop,
    txtCtaBannerDesktop,
    urlImgMobile,
    linkCtaMobile,
    txtCtaBannerMobile,
    corCta,
    corTxtCta,
    corTxtConteudo,
    tituloNotificacao,
  ]);


  const validateField = (value, setError, errorMessage) => {
    if (value) {
      setError(false);
    } else {
      setError(errorMessage);
    }
  };


  const { data: dataUser } = useContext(UserContext);
  const dateTimeStampNow = new Date()
  async function getAll() {

    let dataGroup = [];
    let indice = 0;

    const citiesRef = collection(db, 'oferta-contextual');
    let subCollection = collection(citiesRef, 'ofertas-cadastradas', 'lista-de-ofertas')
    //const q = collection(db, "oferta-contextual");
    const snap = await getDocs(subCollection);
    snap.forEach((doc) => {
      dataGroup.push(doc.data());
      dataGroup[indice]["docID"] = doc.id;
      indice = indice + 1;
    });
    selectedItems = []
    selectedItemsStatus = []
    tempSelectedItemsStatus = []
    setAllData(dataGroup);
  }

  function modalConfirmPub() {
    let updateRef;
    let count = 1;
    selectedItemsStatus.forEach((item) => {
      const citiesRef = collection(db, 'oferta-contextual');
      let subCollection = doc(citiesRef, 'ofertas-cadastradas', 'lista-de-ofertas', item)
      //const updateRef = doc(db, "oferta-contextual", item);

      updateDoc(subCollection, {
        status: 'ativo',
      }).then(function () {
        setTxtModal('Publicação realizada com sucesso.')
        setIsOpenMsg(true);
        if (selectedItemsStatus.length == count) {
          setIsOpenPub(false);
          setAllData([]);
          getAll();
          setShowBtPub(false)
        }

        count = count + 1;
      });
    });

  }

  function onRequestClose() {
    setIsOpen(false);
    setIsOpenPub(false);
  }

  function onRequestCloseMsg() {
    setIsOpenMsg(false);
  }

  function disableForm(e) {
    if (e.target.value == 'banner') {
      setDisabledNotification(false)
      setDisabledBanner('disabled')
    }
    else if (e.target.value == 'notificacao') {
      setDisabledNotification('disabled')
      setDisabledBanner(false)
    }
    else {
      setDisabledBanner(false)
      setDisabledNotification(false)
    }
  }

  useContext(() => {
    (showBtEdit == false && status == 'ativo') && setStatus('preview');
    if (espacoComercial == 'notificacao') {
      setDisabledNotification('disabled')
      setDisabledBanner(false)
    }
  })

  function handleUpdateData() {
    const citiesRef = collection(db, 'oferta-contextual')
    let subCollection = doc(citiesRef, 'ofertas-cadastradas', 'lista-de-ofertas', docID)

    // Atomically increment the population of the city by 50.
    updateDoc(subCollection, {
      tituloNotificacao: tituloNotificacao,
      txtConteudo: txtConteudo,
      produto: produto,
      espacoComercial: espacoComercial,
      urlImgMobile: urlImgMobile,
      urlImgDesktop: urlImgDesktop,
      linkCtaDesktop: linkCtaDesktop,
      linkCtaMobile: linkCtaMobile,
      txtCtaBannerDesktop: txtCtaBannerDesktop,
      txtCtaBannerMobile: txtCtaBannerMobile,
      corCta: corCta,
      corTxtCta: corTxtCta,
      corTxtConteudo: corTxtConteudo,
      status: status,
    }).then(function () {
      setShowForm(false);
      setShowBtAddNew(true)
      setShowTable(true);
      getAll();
      setShowBtEdit(false)
      setShowBtDelete(false)
      setTxtModal('Item atualizado com sucesso.')
      setIsOpenMsg(true)
    });
    addDoc(
      collection(db, 'oferta-contextual-log'), {
      acao: 'editar',
      conteudo: txtConteudo,
      data: dateTimeStampNow,
      email: dataUser?.email,
      espacoComercial: espacoComercial,
      produto: produto,
      status: status,
      titulo: tituloNotificacao
    }).then((e) => {
      ////console.log(e)
    })
  }

  // valida se existe uma oferta do mesmo produto e espaço comercial ativa
  async function checkIfExist(next) {
    //const q = collection(db, 'oferta-contextual');
    let q = "";
    const citiesRef = collection(db, 'oferta-contextual');
    let subCollection = collection(citiesRef, 'ofertas-cadastradas', 'lista-de-ofertas')
    //let subCollection = collection(citiesRef, 'ofertas-cadastradas','lista-de-ofertas', docID)
    //let q = collection(db, 'oferta-contextual');
    if (status == 'ativo') {
      q = query(doc(subCollection), where("status", "==", "ativo"), where("espacoComercial", "==", espacoComercial), where("produto", "==", produto));
    }

    if (status == "preview") {
      q = query(subCollection,
        where("status", "==", "preview"),
        where("espacoComercial", "==", espacoComercial),
        where("produto", "==", produto)
      );
    }

    let qtd = 1;
    if (next == "update") {
      qtd = 2
    }

    if (status != "inativo") {
      // só faz a consulta se o status for nao for inativo
      const snap = await getDocs(q);
      snap.forEach((doc) => {
        let objData = doc.data();
        
      });
      if (snap.size >= qtd) {
        alert(
          "Não foi possível realizar a operação, já existe uma campanha ativa para esse produto!"
        );
      } else {
        if (next == "add") {
          handleAddBQ();
        }
        if (next == "update") {
          handleUpdateData();
        }
      }
    }
    if (status == "inativo") {
      // se for inativo sempre salva ou atualiza o item
      if (next == "add") {
        handleAddBQ();
      }
      if (next == "update") {

      }
    }
  }

  function deleteDataMultipleItems() {
    selectedItems.forEach(function (item) {
      const citiesRef = collection(db, 'oferta-contextual');
      deleteDoc(
        doc(
          collection(citiesRef, 'ofertas-cadastradas', 'lista-de-ofertas'),
          item
        )
      ).then(function () {
        setIsOpen(false)
        setTxtModal('Exclusão realizada com sucesso.')
        setIsOpenMsg(true)
        getAll();
        setShowForm(false);
        setShowBtAddNew(true)
        setShowTable(true);

      });
      addDoc(
        collection(db, 'oferta-contextual-log'), {
        acao: 'deletar',
        conteudo: txtConteudo,
        data: dateTimeStampNow,
        email: dataUser?.email,
        espacoComercial: espacoComercial,
        produto: produto,
        status: status,
        titulo: tituloNotificacao
      }).then((e) => {
        ////console.log(e)
      })
    })

    // limpa checkboxes selecionados
    var checkboxes = document.querySelectorAll('input[type=checkbox]:checked')
    for (var checkbox of checkboxes) {
      checkbox.checked = false;
    }

  }

  function handleCancel() {
    setShowForm(false);
    setShowBtAddNew(true)
    setShowTable(true);
  }

  function getValuesEditData() {
    setTituloNotificacao(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-tituloNotificacao').innerHTML
    );
    setTxtConteudo(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-txtConteudo').innerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
    );
    setProduto(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-produto').innerHTML
    );
    setEspacoComercial(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-espacoComercial').innerHTML
    );
    setUrlImgMobile(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-urlImgMobile').innerHTML
    );
    setUrlImgDesktop(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-urlImgDesktop').innerHTML
    );
    setLinkCtaDesktop(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-linkCtaDesktop').innerHTML
    );
    setLinkCtaMobile(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-linkCtaMobile').innerHTML
    );
    setTxtCtaBannerDesktop(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-txtCtaBannerDesktop').innerHTML
    );
    setTxtCtaBannerMobile(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-txtCtaBannerMobile').innerHTML
    );
    setCorCta(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-corCta').innerHTML
    );
    setCorTxtCta(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-corTxtCta').innerHTML
    );
    setCorTxtConteudo(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-corTxtConteudo').innerHTML
    );
    setStatus(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-status').innerText
    );
    setDocID(
      document.querySelectorAll('input[type=checkbox]:checked')[0].parentNode.parentNode.querySelector('.id-docID span').innerHTML
    );
    setShowForm(true);
    setShowBtEdit(false)
    setShowBtDelete(false)
    setShowBtAddNew(false)
    setShowTable(false);
  }

  function handleCheckbox() {
    //let checked = e.target.checked;
    selectedItems = []
    selectedItemsStatus = []
    tempSelectedItemsStatus = []
    var tempSelectedItems = []

    var checkboxes = document.querySelectorAll('input[type=checkbox]:checked')

    for (var i = 0; i < checkboxes.length; i++) {
      tempSelectedItems.push(checkboxes[i].value)
      selectedItems = tempSelectedItems

      if (checkboxes[i].parentNode.parentNode.getElementsByClassName("id-status")[0].innerText == "preview") {
        tempSelectedItemsStatus.push(checkboxes[i].value)
        selectedItemsStatus = tempSelectedItemsStatus
      }

    }

    abc = tempSelectedItems;

    var checkboxes = document.querySelectorAll('input[type=checkbox]:checked')
    for (var checkbox of checkboxes) {
      checkbox.checked = true;
    }

    if (selectedItems.length == 1) {
      setShowBtDelete(true)
      setShowBtEdit(true)
    }
    else if (selectedItems.length > 1) {
      setShowBtDelete(true)
      setShowBtEdit(false)
    }
    else if (selectedItems.length <= 0) {
      setShowBtDelete(false)
      setShowBtEdit(false)
    }

    if (selectedItemsStatus.length > 0 && selectedItemsStatus.length == selectedItems.length) {// se tiver mais de um item com status ativo selecionado/checado
      setShowBtPub(true)
    }
    else {
      setShowBtPub(false)
    }
  }

  function clearData() {
    setShowForm(true);
    setShowBtEdit(false)
    setShowBtDelete(false)
    setShowBtAddNew(false)
    setShowTable(false);

    setTituloNotificacao("");
    setTxtConteudo("");
    setProduto("");
    setEspacoComercial("");
    setUrlImgMobile("");
    setUrlImgDesktop("");
    setLinkCtaDesktop("");
    setLinkCtaMobile("");
    setTxtCtaBannerDesktop("");
    setTxtCtaBannerMobile("");
    setCorCta("");
    setCorTxtCta("");
    setCorTxtConteudo("");
    setStatus("");
    setDocID("");
  }

  async function handleAddBQ() {
    const citiesRef = collection(db, 'oferta-contextual');
    addDoc(collection(citiesRef, 'ofertas-cadastradas', 'lista-de-ofertas'), {
      tituloNotificacao: tituloNotificacao,
      txtConteudo: txtConteudo,
      produto: produto,
      espacoComercial: espacoComercial,
      urlImgMobile: urlImgMobile,
      urlImgDesktop: urlImgDesktop,
      linkCtaDesktop: linkCtaDesktop,
      linkCtaMobile: linkCtaMobile,
      txtCtaBannerDesktop: txtCtaBannerDesktop,
      txtCtaBannerMobile: txtCtaBannerMobile,
      corCta: corCta,
      corTxtCta: corTxtCta,
      corTxtConteudo: corTxtConteudo,
      status: status,
    }).then(function () {
      getAll();
      setShowForm(false);
      setShowBtAddNew(true)
      setShowTable(true);
      setShowBtEdit(false)
      setShowBtDelete(false)
      setTxtModal('Item adicionado com sucesso.')
      setIsOpenMsg(true)
    });
    addDoc(
      collection(db, 'oferta-contextual-log'), {
      acao: 'adicionar',
      conteudo: txtConteudo,
      data: dateTimeStampNow,
      email: dataUser?.email,
      espacoComercial: espacoComercial,
      produto: produto,
      status: status,
      titulo: tituloNotificacao
    }).then((e) => {
      ////console.log(e)
    })

  }


  return (

    <>
      <div className={styles.container}>
        <Modal
          isOpen={isOpen}
          ariaHideApp={false}
          contentLabel="Selected Option"
          overlayClassName="react-modal-overlay-logout"
          className="react-modal-content-logout"
          onRequestClose={onRequestClose}
        >
          {" "}
          <button
            className="react-modal-close"
            type="button"
            onClick={onRequestClose}
          >
            <span>&#x2715;</span>
          </button>
          <div className={styles.contentModal}>
            <h2>Deseja excluir os itens selecionados?</h2>
            <div className={styles.contentModalBtn}>
              <button onClick={function (event) {
                deleteDataMultipleItems();
              }}>Sim</button>
              <button onClick={onRequestClose}>Não</button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isOpenPub}
          ariaHideApp={false}
          contentLabel="Selected Option"
          overlayClassName="react-modal-overlay-logout"
          className="react-modal-content-logout"
          onRequestClose={onRequestClose}
        >
          {" "}
          <button
            className="react-modal-close"
            type="button"
            onClick={onRequestClose}
          >
            <span>&#x2715;</span>
          </button>
          <div className={styles.contentModal}>
            <h2>Deseja publicar os itens selecionados?</h2>
            <div className={styles.contentModalBtn}>
              <button onClick={function (event) {
                modalConfirmPub();
              }}>Sim</button>
              <button onClick={onRequestClose}>Não</button>
            </div>
          </div>
        </Modal>
      </div>
      <div className={styles.container}>
        <Modal
          isOpen={isOpenMsg}
          ariaHideApp={false}
          contentLabel="Selected Option"
          overlayClassName="react-modal-overlay-logout"
          className="react-modal-content-logout"
          onRequestClose={onRequestCloseMsg}
        >
          {" "}
          <button
            className="react-modal-close"
            type="button"
            onClick={onRequestCloseMsg}
          >
            <span>&#x2715;</span>
          </button>
          <div className={styles.contentModal}>
            <h2>{txtModal}</h2>
            <div className={styles.contentModalBtn}>
              <button onClick={onRequestCloseMsg}>Ok</button>
            </div>
          </div>
        </Modal>
      </div>
      <div className={styles.containerPage}>
        <section className={`${styles.sectionWebPush} container`}>
          <div className="title-page">
            <LogoOfertas />
            <h1> Ofertas </h1>
            {showHideButtons()}
          </div>

          {/* <a href="https://www.santander.com.br/?oferta-contextual=preview">
      Preview
    </a> */}

          <div className={styles.containerPageWebPush}>
            {showForm && (
              <div className={styles.formsPageWebPush}>
                <br />
                <div className={styles.infoOferta}>
                  <div className={styles.item}>
                    <SelectField
                      value={espacoComercial}
                      onChange={(e) => {
                        disableForm(e);
                        setEspacoComercial(e.target.value);
                        validateField(e.target.value, setEspacoComercialError, 'Selecione um espaço comercial');
                      }}
                      onBlur={({ target }) => {
                        validateField(target.value, setEspacoComercialError, 'Selecione um espaço comercial');
                      }}
                      options={[
                        { value: 'banner', label: 'Banner' },
                        { value: 'notificacao', label: 'Notificação' }
                      ]}
                      error={espacoComercialError}
                      placeholder="Espaço Comercial"
                    />
                  </div>
                  <div className={styles.item}>
                    <SelectField
                      value={produto}
                      onChange={({ target }) => {
                        setProduto(target.value);
                        validateField(target.value, setProdutoError, 'Selecione um produto');
                      }}
                      onBlur={({ target }) => {
                        validateField(target.value, setProdutoError, 'Selecione um produto');
                      }}
                      options={[
                        { value: 'conta-pf', label: 'Conta pessoa física' },
                        { value: 'renegociacao', label: 'Renegociação' }
                      ]}
                      error={produtoError}
                      placeholder="Produto"
                    />
                    <div className={styles.required}>{espacoComercial && '*'}</div>
                  </div>
                  <div className={styles.item}>
                    <SelectField
                      value={status}
                      onChange={({ target }) => {
                        setStatus(target.value);
                        validateField(target.value, setStatusError, 'Selecione um status');
                      }}
                      onBlur={({ target }) => {
                        validateField(target.value, setStatusError, 'Selecione um status');
                      }}
                      options={[
                        { value: 'preview', label: 'Preview' },
                        { value: 'inativo', label: 'Inativo' }
                      ]}
                      error={statusError}
                      placeholder="Status"
                    />
                    <div className={styles.required}>{espacoComercial && '*'}</div>
                  </div>
                </div>
                <div className={styles.addOferta}>
                  <Input
                    required={espacoComercial === 'notificacao' ? 'required' : ''}
                    value={tituloNotificacao}
                    onBlur={({ target }) => {
                      validateField(target.value, setTituloNotificacaoError, 'Digite um titulo para a notificação');
                    }}
                    onChange={({ target }) => {
                      setTituloNotificacao(target.value);
                      validateField(target.value, setTituloNotificacaoError, 'Digite um titulo para a notificação');
                    }}
                    error={tituloNotificacaoError}
                    placeholder="Título da notificação"
                    type="text"
                    disabled={disabledBanner}
                    wrapper={styles.tituloWrapper}
                  />
                  <Input
                    required={espacoComercial && 'required'}
                    value={txtConteudo}
                    onBlur={({ target }) => {
                      validateField(target.value, setTxtConteudoError, 'Digite o conteudo para a notificação');
                    }}
                    onChange={({ target }) => {
                      setTxtConteudo(target.value);
                      validateField(target.value, setTxtConteudoError, 'Digite o conteudo para a notificação');
                    }}
                    error={txtConteudoError}
                    placeholder="Conteúdo"
                    type="text"
                  />
                </div>
                <section className={styles.row}>
                  <div className={styles.item}>
                    Desktop
                    <Input
                      required={espacoComercial === 'banner' ? 'required' : ''}
                      value={urlImgDesktop}
                      onBlur={({ target }) => {
                        validateField(target.value, setUrlImgDesktopError, 'Digite a URL da imagem de fundo (Desktop)');
                      }}
                      onChange={({ target }) => {
                        setUrlImgDesktop(target.value);
                        validateField(target.value, setUrlImgDesktopError, 'Digite a URL da imagem de fundo (Desktop)');
                      }}
                      error={urlImgDesktopError}
                      placeholder="URL da imagem Desktop"
                      type="text"
                      disabled={disabledNotification}
                    />
                    <Input
                      required={espacoComercial && 'required'}
                      value={linkCtaDesktop}
                      onBlur={({ target }) => {
                        validateField(target.value, setLinkCtaDesktopError, 'Insira um Link para o CTA (Desktop)');
                      }}
                      onChange={({ target }) => {
                        setLinkCtaDesktop(target.value);
                        validateField(target.value, setLinkCtaDesktopError, 'Insira um Link para o CTA (Desktop)');
                      }}
                      error={linkCtaDesktopError}
                      placeholder="Link CTA Desktop"
                      type="text"
                    />
                    <Input
                      required={espacoComercial === 'banner' ? 'required' : ''}
                      value={txtCtaBannerDesktop}
                      onBlur={({ target }) => {
                        validateField(target.value, setTxtCtaBannerDesktopError, 'Insira um texto para o banner (Desktop)');
                      }}
                      onChange={({ target }) => {
                        setTxtCtaBannerDesktop(target.value);
                        validateField(target.value, setTxtCtaBannerDesktopError, 'Insira um texto para o banner (Desktop)');
                      }}
                      error={txtCtaBannerDesktopError}
                      placeholder="Texto do link do desktop"
                      type="text"
                      disabled={disabledNotification}
                    />
                  </div>
                  <div className={styles.item}>
                    Mobile
                    <Input
                      required={espacoComercial === 'banner' ? 'required' : ''}
                      value={urlImgMobile}
                      onBlur={({ target }) => {
                        validateField(target.value, setUrlImgMobileError, 'Digite a URL da imagem de fundo (Mobile)');
                      }}
                      onChange={({ target }) => {
                        setUrlImgMobile(target.value);
                        validateField(target.value, setUrlImgMobileError, 'Digite a URL da imagem de fundo (Mobile)');
                      }}
                      error={urlImgMobileError}
                      placeholder="URL da imagem mobile"
                      type="text"
                      disabled={disabledNotification}
                    />
                    <Input
                      required={espacoComercial && 'required'}
                      value={linkCtaMobile}
                      onBlur={({ target }) => {
                        validateField(target.value, setLinkCtaMobileError, 'Insira um Link para o CTA (Mobile)');
                      }}
                      onChange={({ target }) => {
                        setLinkCtaMobile(target.value);
                        validateField(target.value, setLinkCtaMobileError, 'Insira um Link para o CTA (Mobile)');
                      }}
                      error={linkCtaMobileError}
                      placeholder="Link CTA Mobile"
                      type="text"
                    />
                    <Input
                      required={espacoComercial === 'banner' ? 'required' : ''}
                      value={txtCtaBannerMobile}
                      onBlur={({ target }) => {
                        validateField(target.value, setTxtCtaBannerMobileError, 'Insira um texto para o banner (Mobile)');
                      }}
                      onChange={({ target }) => {
                        setTxtCtaBannerMobile(target.value);
                        validateField(target.value, setTxtCtaBannerMobileError, 'Insira um texto para o banner (Mobile)');
                      }}
                      error={txtCtaBannerMobileError}
                      placeholder="Texto do link do mobile"
                      type="text"
                      disabled={disabledNotification}
                    />
                    <br />
                  </div>
                  <div className={styles.item}>
                    Layout
                    <div className={styles.wrapper}>
                      <select
                        className={`${styles.selectLayout} ${corCtaError ? styles.inputError : ''}`}
                        value={corCta}
                        onChange={({ target }) => {
                          setCorCta(target.value);
                          validateField(target.value, setCorCtaError, 'Selecione uma cor de fundo para o CTA');
                        }}
                        onBlur={({ target }) => {
                          validateField(target.value, setCorCtaError, 'Selecione uma cor de fundo para o CTA');
                        }}
                        disabled={disabledNotification}
                      >
                        <option value=""> Cor de fundo do CTA:</option>
                        <option value="#fff">Branco</option>
                        <option value="#cc0000">Vermelho</option>
                      </select>
                      <div className={styles.required}>{espacoComercial === 'banner' && '*'}</div>
                      <p className={styles.error}>{corCtaError}</p>
                    </div>
                    <div className={styles.wrapper}>
                      <select
                        className={`${styles.selectLayout} ${corTxtCtaError ? styles.inputError : ''}`}
                        value={corTxtCta}
                        onChange={({ target }) => {
                          setCorTxtCta(target.value);
                          validateField(target.value, setCorTxtCtaError, 'Selecione uma cor para o texto do CTA');
                        }}
                        onBlur={({ target }) => {
                          validateField(target.value, setCorTxtCtaError, 'Selecione uma cor para o texto do CTA');
                        }}
                        disabled={disabledNotification}
                      >
                        <option value=""> Cor do texto do CTA:</option>
                        <option value="#fff">Branco</option>
                        <option value="#cc0000">Vermelho</option>
                      </select>
                      <div className={styles.required}>{espacoComercial === 'banner' && '*'}</div>
                      <p className={styles.error}>{corTxtCtaError}</p>
                    </div>
                    <div className={styles.wrapper}>
                      <select
                        className={`${styles.selectLayout} ${corTxtConteudoError ? styles.inputError : ''}`}
                        value={corTxtConteudo}
                        onChange={({ target }) => {
                          setCorTxtConteudo(target.value);
                          validateField(target.value, setCorTxtConteudoError, 'Selecione uma cor para o texto do conteúdo');
                        }}
                        onBlur={({ target }) => {
                          validateField(target.value, setCorTxtConteudoError, 'Selecione uma cor para o texto do conteúdo');
                        }}
                        disabled={disabledNotification}
                      >
                        <option value="">Cor do texto do conteúdo:</option>
                        <option value="#fff">Branco</option>
                        <option value="#000">Preto</option>
                      </select>
                      <div className={styles.required}>{espacoComercial === 'banner' && '*'}</div>
                      <p className={styles.error}>{corTxtConteudoError}</p>
                    </div>
                  </div>
                </section>
                <div className="flex-row-justified" style={{ width: '50%', flex: 'flex-end' }}>
                  <Button className={styles.btnWebPush} onClick={handleCancel}>
                    Voltar
                  </Button>
                  {saveButtonState && espacoComercial && (
                    <Button className={styles.btnWebPush} onClick={() => checkIfExist('add')}>
                      Salvar
                    </Button>
                  )}
                  {showBtUpdate && espacoComercial && (
                    <Button className={styles.btnWebPush} onClick={() => checkIfExist('update')}>
                      Atualizar
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>

          {
            showTable && (
              <div className={styles.tabela}>
                <table>
                  <thead>
                    <tr>
                      <th>
                        {/* <input type="checkbox" /> */}
                      </th>
                      <th>
                        Título da notificação
                      </th>
                      <th>Conteúdo</th>
                      <th>Produto</th>
                      <th>Espaço</th>
                      <th>Status</th>
                      <th className={styles.hide}>Imagem Mobile</th>
                      <th className={styles.hide}>Imagem Desktop</th>
                      <th className={styles.hide}>Link CTA Desktop</th>
                      <th className={styles.hide}>Link CTA Mobile</th>
                      <th className={styles.hide}>Texto do CTA do Banner Desktop</th>
                      <th className={styles.hide}>Texto do CTA do Banner Mobile</th>
                      <th className={styles.hide}>Cor de fundo do CTA</th>
                      <th className={styles.hide}>Cor do texto do CTA</th>
                      <th className={styles.hide}>Cor do texto do conteúdo</th>

                      {/* <th>Editar</th>
            <th>Excluir</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {allData.map((dataItem) => (
                      <tr>
                        <td className={'id-docID'}><input type="checkbox" value={dataItem.docID} onClick={function (event) {
                          handleCheckbox(event);
                        }} />
                          <span className={'uuidHidden ' + styles.uuid}>{dataItem.docID}</span>
                        </td>
                        <td className={'id-tituloNotificacao'}>
                          {dataItem.tituloNotificacao}
                        </td>
                        <td className={'id-txtConteudo'}>{dataItem.txtConteudo}</td>
                        <td className={'id-produto'}>{dataItem.produto}</td>
                        <td className={'id-espacoComercial'}>{dataItem.espacoComercial}</td>
                        <td className={'id-status'}>{dataItem.status == 'preview' && (<a target="_blank" href="https://www.santander.com.br?oferta-contextual=preview">{dataItem.status}</a>)}{dataItem.status != 'preview' && (dataItem.status)}</td>
                        <td className={'id-urlImgMobile ' + styles.hide}>{dataItem.urlImgMobile}</td>
                        <td className={'id-urlImgDesktop ' + styles.hide}>{dataItem.urlImgDesktop}</td>
                        <td className={'id-linkCtaDesktop ' + styles.hide}>{dataItem.linkCtaDesktop}</td>
                        <td className={'id-linkCtaMobile ' + styles.hide}>{dataItem.linkCtaMobile}</td>
                        <td className={'id-txtCtaBannerDesktop ' + styles.hide}>{dataItem.txtCtaBannerDesktop}</td>
                        <td className={'id-txtCtaBannerMobile ' + styles.hide}>{dataItem.txtCtaBannerMobile}</td>
                        <td className={'id-corCta ' + styles.hide}>{dataItem.corCta}</td>
                        <td className={'id-corTxtCta ' + styles.hide}>{dataItem.corTxtCta}</td>
                        <td className={'id-corTxtConteudo ' + styles.hide}>{dataItem.corTxtConteudo}</td>

                        {/* <td>
                      {" "}
                      <a
                        className={styles.icEdit}
                        onClick={function (event) {
                          setShowForm(true);
                          setShowBtUpdate(true);
                          setShowBtSave(false);
                          handleEditData();
                        }}
                      >
                        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEyOCAxMjg7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMzMUFGOTE7fQoJLnN0MXtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjY0IiBjeT0iNjQiIHI9IjY0Ii8+PGc+PHBhdGggY2xhc3M9InN0MSIgZD0iTTg3LjQsNTAuNWw5LjktOS45YzAuNC0wLjQsMC40LTEsMC0xLjRsLTguNS04LjVjLTAuNC0wLjQtMS0wLjQtMS40LDBsLTkuOSw5LjlMODcuNCw1MC41eiIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik03NC42LDQzLjVMMzgsODAuMWwtNC40LDEzYy0wLjMsMC44LDAuNSwxLjUsMS4zLDEuM2wxMy00LjRsMzYuNi0zNi42TDc0LjYsNDMuNXoiLz48L2c+PC9zdmc+" />
                      </a>{" "}
                      <span className={styles.uuid}>{dataItem.docID}</span>
                    </td>
                    <td>
                      {" "}
                      <a
                        className={styles.icDelete}
                        onClick={function (event) {
                          handleDeleteData();
                        }}
                      >
                        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMiA3OTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA2MTIgNzkyIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNFNDQwNjE7fQo8L3N0eWxlPjxnPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01NjIsMzk2YzAtMTQxLjQtMTE0LjYtMjU2LTI1Ni0yNTZTNTAsMjU0LjYsNTAsMzk2czExNC42LDI1NiwyNTYsMjU2UzU2Miw1MzcuNCw1NjIsMzk2TDU2MiwzOTZ6IE0zNTYuOCwzOTYgICBMNDc1LDUxNC4yTDQyNC4yLDU2NUwzMDYsNDQ2LjhMMTg3LjgsNTY1TDEzNyw1MTQuMkwyNTUuMiwzOTZMMTM3LDI3Ny44bDUwLjgtNTAuOEwzMDYsMzQ1LjJMNDI0LjIsMjI3bDUwLjgsNTAuOEwzNTYuOCwzOTYgICBMMzU2LjgsMzk2eiIvPjwvZz48L3N2Zz4=" />
                      </a>{" "}
                      <span className={styles.uuid}>{dataItem.docID}</span>
                    </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          }
          <div className={styles.paginas} style={{ "display": "none" }}>
            <p>Itens por página:</p>
            <ul className={styles.pagination}>
              <li>
                <a href="#">«</a>
              </li>
              <li>
                <a href="#">1</a>
              </li>
              <li>
                <a className="active" href="#">
                  2
                </a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>
                <a href="#">4</a>
              </li>
              <li>
                <a href="#">5</a>
              </li>
              <li>
                <a href="#">6</a>
              </li>
              <li>
                <a href="#">7</a>
              </li>
              <li>
                <a href="#">»</a>
              </li>
            </ul>
          </div>
        </section >
      </div >
    </>
  );
};

export default OfertaContextual;
